export const TEMPLATE_FIELD_TYPES = ['text', 'multiline', 'number', 'date', 'select'] as const;
export type TemplateFieldType = (typeof TEMPLATE_FIELD_TYPES)[number];

export const TEMPLATE_FIELD_FILL_BY = ['member', 'writer', 'either'] as const;
export type TemplateFieldFillBy = (typeof TEMPLATE_FIELD_FILL_BY)[number];

export type TemplateFieldPlacement =
  | { kind: 'token'; find: string }
  | { kind: 'labelValue'; rowLabel: string }
  | { kind: 'column'; tableBlockId: number; column: string };

export interface TemplateField {
  key: string;
  label: string;
  type: TemplateFieldType;
  options?: string[];
  allowOther?: boolean;
  required?: boolean;
  fillBy: TemplateFieldFillBy;
  placement: TemplateFieldPlacement;
}

export interface TemplateEntryField {
  key: string;
  label: string;
  type: TemplateFieldType;
  options?: string[];
  allowOther?: boolean;
  required?: boolean;
  fillBy: TemplateFieldFillBy;
  group?: string;
}

export interface TemplateEntryCategory {
  label: string;
  items: string[];
}

export interface TemplateEntryDef {
  itemLabel: string;
  categories?: TemplateEntryCategory[];
  allowCustomItem?: boolean;
  fields: TemplateEntryField[];
  photos: boolean;
  notes: boolean;
}

export interface ParsedTemplateEntry {
  entryNumber: number;
  title: string;
  category: string | null;
  values: Record<string, string>;
  photoCodes: string[];
  notes: string | null;
  warnings: string[];
}
